import http from "../utils/http-common";

const getById = (id: number) => {
  return http.get(`/agent/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/agent/${id}`, data);
};
const remove = (id: number) => {
  return http.delete(`/agent/${id}`);
};
const post = (data: any) => {
  return http.post(`/agent`, data);
};
// const getAll = (params: string) => {
//   const queryString = new URLSearchParams(params).toString();
//   return http.get(`/agent?${queryString}`);
// };

const getAll = () => {
  return http.get(`/agent`);
};

const agentService = {
  getById,
  put,
  remove,
  post,
  getAll,
};
export default agentService;
